import { SidePanelState } from 'stores/types';

export const initialState: SidePanelState = {
  showSidePanel: true,
};
